import {
  TBarcodeScannerLogColumnKey,
} from './debug-barcode-scanner.ts';

const columns: Record<TBarcodeScannerLogColumnKey, string> = {
  timestampEpochMilliseconds: 'Timestamp',
  eventType: 'Event',
  characterLabel: 'Character',
  isControlCharacter: 'Control character',
  key: 'Key',
  code: 'Code',
  keyCode: 'Key code',
  modifierList: 'Modifiers',
  inputType: 'Input type',
  inputValueSnapshot: 'Field value',
};

export default {
  description: 'Click into the field below and scan a barcode to see every keyboard and input event the browser fires, in the order they occur. The most recent event is shown at the top of the log. Non-printable control characters are shown using their standard abbreviation, for example <GS> for the Group Separator (0x1D).',
  scanInputPlaceholder: 'Click here and scan a barcode',
  eventCount: '{count} events logged',
  copyLogButtonLabel: 'Copy log',
  clearButtonLabel: 'Clear',
  emptyLog: 'No events yet. Scan a barcode to start logging.',
  columns,
};
